<template>
    <div class="popular-trips__filter">
        <button
            v-for="button in popular.filter"
            :class="{ active: button.active }"
            @click="toggleActive(button)"
        >
            {{ button.label }}
        </button>
    </div>
</template>
<script>
import { usePopularStore } from "@/vue/stores/popular.js";
export default {
    data() {
        return {
            popular: usePopularStore(),
        };
    },
    methods: {
        toggleActive(button) {
            this.popular.setActiveFilter(button)
        }
    }
};
</script>
<style lang="scss" scoped>
.popular-trips__filter {
    display: flex;
    flex-wrap: wrap;

    button {
        display: block;
        border: 1px solid var(--color-grey-200);
        border-radius: 8px;
        color: var(--color-grey-900);
        padding: 3px 9px;
        margin-right: 1em;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        cursor: pointer;

        &:hover {
            background-color: var(--color-blue-400);
            border: 1px solid var(--color-blue-400);
            color: var(--color-white);
        }
    }

    .active {
        background-color: var(--color-blue-400);
        border: 1px solid var(--color-blue-400);
        color: var(--color-white);
    }
}
</style>
